<template>
	<div v-show="visible" class="loading-wrap">
		<div class="loading-box">
			<div class="loader">
				<div class="loading-square"></div>
				<div class="loading-square"></div>
				<div class="loading-square"></div>
				<div class="loading-square"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			visible: true
		}
	}
}
</script>
<style lang="scss" scoped>
$box1_color: #303133;
$box2_color: #525F7F;
$box3_color: #E7EBF1;
$change_color: #303133;

.loading-wrap {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
  bottom: 0;
  z-index: 99;
	// background-color: rgba(0,0,0,.2);
	background-color:hsla(0,0%,100%,.9);
}
.loading-box {
	position: absolute;
	left: 50%;
	top: 50%;
	width: 100px;
	transform: translate(-50%, -50%);
}

.loader {
  display: block;
  position: relative;
  height: 20px;
  width: 86px;
  transform: scale(.4);
  opacity: .7;
}

.loading-square {
  position: absolute;
  height: 20px;
  width: 20px;
  top: 0;
}

.loading-square:nth-child(1) {
  left: 0;
  animation: square1 1.5s linear forwards infinite;
}

.loading-square:nth-child(2) {
  left: 22px;
  animation: square2 1.5s linear forwards infinite;
}

.loading-square:nth-child(3) {
  left: 44px;
  animation: square3 1.5s linear forwards infinite;
}

.loading-square:nth-child(4) {
  left: 66px;
  animation: square4 1.5s linear forwards infinite;
}

@keyframes square1 {
  0% {
    background-color: $change_color;
    transform: translate(0, 0);
  }
  9.09091% {
    transform: translate(0, calc(-100% - 2px));
    background-color: $change_color;
  }
  18.18182% {
    transform: translate(calc(100% + 2px), calc(-100% - 2px));
    background-color: $box1_color;
  }
  27.27273% {
    transform: translate(calc(100% + 2px), 0);
  }
  100% {
    background-color: $box1_color;
    transform: translate(calc(100% + 2px), 0);
  }
}
@keyframes square2 {
  0% {
    background-color: $box1_color;
    transform: translate(0, 0);
  }
  18.18182% {
    transform: translate(0, 0);
  }
  27.27273% {
    transform: translate(0, calc(100% + 2px));
    background-color: $box1_color;
  }
  36.36364% {
    transform: translate(calc(100% + 2px), calc(100% + 2px));
    background-color: $box2_color;
  }
  45.45455% {
    transform: translate(calc(100% + 2px), 0);
  }
  100% {
    background-color: $box2_color;
    transform: translate(calc(100% + 2px), 0);
  }
}
@keyframes square3 {
  0% {
    background-color: $box2_color;
    transform: translate(0, 0);
  }
  36.36364% {
    transform: translate(0, 0);
  }
  45.45455% {
    transform: translate(0, calc(-100% - 2px));
    background-color: $box2_color;
  }
  54.54545% {
    transform: translate(calc(100% + 2px), calc(-100% - 2px));
    background-color: $box3_color;
  }
  63.63636% {
    transform: translate(calc(100% + 2px), 0);
  }
  100% {
    background-color: $box3_color;
    transform: translate(calc(100% + 2px), 0);
  }
}
@keyframes square4 {
  0% {
    transform: translate(0, 0);
    background-color: $box3_color;
  }
  54.54545% {
    transform: translate(0, 0);
  }
  63.63636% {
    transform: translate(0, calc(100% + 2px));
    background-color: $box3_color;
  }
  72.72727% {
    background-color: $box2_color;
  }
  81.81818% {
    background-color: $box1_color;
  }
  90.90909% {
    transform: translate(calc(-300% - 6px), calc(100% + 2px));
    background-color: $change_color;
  }
  100% {
    transform: translate(calc(-300% - 6px), 0);
    background-color: $change_color;
  }
}
</style>


// WEBPACK FOOTER //
// src/directive/loading/loading.vue